<template>
  <div class="o-focus o-tabs__tab--fixed-head">
    <div class="o-panel__header" v-my-fixed-title>
      <h3 class="o-panel__title">Delivering innovation across the business</h3>
    </div>

    <my-slider>
      <!-- SLIDE -->
      <my-slide>
        <div class="o-panel__body">
          <div class="o-focus__intro">
            <p>We are committed to finding ways to improve what we do for our customers. Innovation for us is all about providing a better, cheaper, safer and greener service. It is as much about finding new ways of doing what we do as it is about high tech advances. We are always looking ahead to how things might develop, but we never lose sight of the reason we are here: to keep the lights on.</p>
          </div>

          <div class="o-link__btn-group">
            <my-download-button :section="'focus-innovation'"></my-download-button>
            <my-video-button :video-code="'238365779'"></my-video-button>
          </div>
        </div>
      </my-slide>

      <!-- SLIDE -->
      <my-slide>
        <div class="o-panel__body o-panel__body--full">
          <div class="o-grid o-grid--3">

            <div class="o-grid__item o-grid__item--max">
              <div class="o-kpi--circle o-kpi--circle--top o-kpi--circle--red">
                <div class="o-kpi--circle__inner">
                  <h4 class="o-kpi__figure">864</h4>
                  <p class="o-kpi__caption">Households’ worth of CO<sub>2</sub> emissions avoided by repairing faults by the MAAV project</p>
                </div>
              </div>
            </div>

            <div class="o-grid__item o-grid__item--max">
              <div class="o-kpi--circle o-kpi--circle--top o-kpi--circle--red">
                <div class="o-kpi--circle__inner">
                  <h4 class="o-kpi__figure">£120m</h4>
                  <p class="o-kpi__caption">Innovation benefits delivered to customers over the last two years</p>
                </div>
              </div>
            </div>

            <div class="o-grid__item o-grid__item--max">
              <div class="o-kpi--circle o-kpi--circle--top o-kpi--circle--red">
                <div class="o-kpi--circle__inner">
                  <h4 class="o-kpi__figure">£18.2m</h4>
                  <p class="o-kpi__caption">Investment in innovation since the start of RIIO-ED1 price control in 2015/16</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </my-slide>

    </my-slider>

  </div>
</template>

<script>
import MyChart from '@/components/standard/my-chart'
import MyDownloadButton from '@/components/standard/my-download-button'
import MyVideoButton from '@/components/standard/my-video-button'
import { MySlider, MySlide } from '@/components/standard/my-slider'
import { MyFixedTitle } from '@/directives/my-fixed-title.js'

export default {
  name: 'my-focus-stake',
  components: {
    MyChart,
    MyDownloadButton,
    MyVideoButton,
    MySlider,
    MySlide
  },
  directives: {
    MyFixedTitle
  }
}
</script>



// WEBPACK FOOTER //
// MyFocusInno.vue?4e789846